import { render, staticRenderFns } from "./ModalProjectUsers.vue?vue&type=template&id=254ff88f&"
import script from "./ModalProjectUsers.vue?vue&type=script&lang=js&"
export * from "./ModalProjectUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports